(() => {
  const normalize = value => value.normalize('NFKC').toLowerCase().replace(/[ァ-ヶ]/g, c => String.fromCharCode(c.charCodeAt(0) - 0x60)).replace(/[\s’'・‐―-]/g, '');
  const init = scope => scope.querySelectorAll('[data-tbw]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    root.addEventListener('submit', async event => {
        const form = event.target.closest('[data-tbw-buy]');
        if (!form) return;
        event.preventDefault();
        if (form.dataset.busy || !form.reportValidity()) return;
        form.dataset.busy = 'true';
        const destination = event.submitter?.value || form.dataset.cartUrl;
        const error = form.querySelector('[data-buy-error]');
        const buttons = [...form.querySelectorAll('button')];
        const data = new FormData(form);
        error.hidden = true;
        buttons.forEach(button => {button.disabled = true;});
        form.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(form.action.replace(/\/add\/?$/, '/add.js'), {
            method: 'POST', body: data, headers: {'Accept': 'application/json'}
          });
          const result = await response.json();
          if (!response.ok || result.status >= 400) throw new Error('Cart rejected');
          window.location.assign(destination);
        } catch {
          error.hidden = false;
          buttons.forEach(button => {button.disabled = false;});
          form.removeAttribute('aria-busy');
          delete form.dataset.busy;
        }
    });
    const input = root.querySelector('[data-whisky-search]');
    if (!input) return;
    const grid = root.querySelector('[data-whisky-grid]');
    const cards = Array.from(grid.querySelectorAll('[data-whisky-card]'));
    cards.sort((a,b) => Number(a.dataset.priority || 9999) - Number(b.dataset.priority || 9999)).forEach(c => grid.appendChild(c));
    const select = root.querySelector('[data-category-select]');
    const reset = root.querySelector('[data-reset]');
    let limit = 24;
    const more = root.querySelector('[data-show-more]');
    const categoryGroup = value => ({'日本／ワールド':'日本','ブレンデッド・スコッチ':'スコッチ','シングルモルト・スコッチ':'スコッチ','バーボン／アメリカン':'アメリカン／バーボン','台湾／インド／その他ワールド':'その他'}[value] || value);
    const update = () => {
      const terms = input.value.trim().split(/\s+/).filter(Boolean).map(normalize);
      let count = 0;
      cards.forEach(card => {
        const match = (!select.value || categoryGroup(card.dataset.category) === select.value) && terms.every(term => normalize(card.dataset.search).includes(term));
        if (match) count++;
        card.hidden = !match || count > limit;
      });
      root.querySelector('[data-count]').textContent = String(count);
      if (more) more.hidden = count <= limit;
      root.querySelector('[data-empty]').hidden = count !== 0;
      reset.hidden = !terms.length && !select.value;
      root.querySelector('[data-list-heading]').textContent = terms.length ? '検索結果' : select.value ? select.value + 'の銘柄' : 'ウイスキー一覧';
      root.querySelector('.tbw-popular').hidden = !!terms.length || !!select.value;
    };
    input.addEventListener('input', () => {limit = 24; update();});
    select.addEventListener('change', () => {limit = 24; update();});
    const clear = () => {input.value = ''; select.value = ''; limit = 24; update(); input.focus();};
    root.querySelector('[data-clear]').addEventListener('click', clear);
    reset.addEventListener('click', clear);
    if (more) more.addEventListener('click', () => {limit += 24; update();});
    update();
  });
  init(document);
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-tbw-buy][data-busy]').forEach(form => {
      delete form.dataset.busy;
      form.removeAttribute('aria-busy');
      form.querySelectorAll('button').forEach(button => {button.disabled = false;});
    });
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
